import React from "react";
import ReactApexChart from "react-apexcharts";

interface GraphDetails {
    allData: {
        names: string;
        scores: string;
    };
}

const CopingSkillsInventoryGraph: React.FC<GraphDetails> = ({ allData }) => {

    // Convert string → array
    const totalItem = (allData?.data || []).find(
        (item: any) => item.name === "Total"
    );
    const filteredData = (allData?.data || []).filter(
        (item: any) => item.name !== "Total"
    );
    const labels = filteredData.map((item: any) => item.name);
    const values = filteredData.map((item: any) => Number(item.total_score));
    const tabVal = allData?.data || [];

    // Chart Options
    const optionsBar: any = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false }
        },

        plotOptions: {
            bar: {
                columnWidth: "45%",
                borderRadius: 4,
            }
        },

        xaxis: {
            categories: labels,   // ✅ IMPORTANT
            labels: {
                rotate: -30,
                style: { colors: "#777", fontSize: "12px" }
            }
        },

        yaxis: {
            min: 0,
            max: 30,
            tickAmount: 6,
            title: {
                text: "Scores"
            }
        },

        dataLabels: {
            enabled: false
        },

        colors: ["#1eb0d5"],

        tooltip: {
            y: {
                formatter: (val: number) => `${val}`
            }
        }
    };

    // Series (MANDATORY)
    const series = [
        {
            name: "Score",
            data: values
        }
    ];

    return (
        <div id="bar">
            {totalItem && (
                <div className="row">
                    <h5 className="mb-1">
                        <strong>Total: {totalItem.total_score}</strong> &nbsp;
                    {totalItem.interpretation}
                    </h5>
                </div>
            )}
            <ReactApexChart
                options={optionsBar}
                series={series}
                type="bar"   // ✅ FIXED
                height={300}
                width="100%"
            />

            <table className="table table-bordered mt-4">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Interpretation</th>
                    </tr>
                </thead>
                <tbody>
                    {tabVal.filter((item: any) => item.name !== "Total")
                        .map((item: any, index: number) => (
                            <tr key={index}>
                                <td>{item.name}</td>
                                <td className="text-wrap">{item.interpretation}</td>
                            </tr>
                        ))}
                </tbody>
            </table>

        </div>
    );
};

export default CopingSkillsInventoryGraph;